document.addEventListener("DOMContentLoaded", () => {

  function initAddToCart() {

    const button = document.querySelector("[ref='addToCartButton']");
    if (!button) return;

    const textSpan = button.querySelector(".add-to-cart-text__content");
    if (!textSpan) return;

    const qtyInput = document.querySelector("input[name='quantity']");
    const variantInput = document.querySelector("form[action='/cart/add'] input[name='id']");

    if (!qtyInput || !variantInput) return;

    function formatMoney(cents) {
      return "$" + (cents / 100).toFixed(2);
    }

    function getVariantPrice() {
      const variantId = variantInput.value;

      if (window.ShopifyAnalytics?.meta?.product?.variants) {
        const variants = window.ShopifyAnalytics.meta.product.variants;
        const variant = variants.find(v => v.id == variantId);
        if (variant) return variant.price;
      }
      return 0;
    }

    function updateButton() {
      const quantity = parseInt(qtyInput.value) || 1;
      const price = getVariantPrice();

      if (!price) return;

      const total = quantity * price;

      textSpan.innerText = `ADD To Cart - ${formatMoney(total)}`;
    }

    // Watch quantity changes
    qtyInput.addEventListener("change", updateButton);
    qtyInput.addEventListener("input", updateButton);

    // When user clicks + or -
    document.addEventListener("click", function (e) {
      if (e.target.closest(".quantity-selector__button") || 
          e.target.closest(".quantity-selector")) {
        setTimeout(updateButton, 150);
      }
    });

    // Watch variant change
    document.addEventListener("change", function(e) {
      if (e.target.name === "id") {
        setTimeout(updateButton, 200);
      }
    });

    updateButton();
  }

  initAddToCart();

  document.addEventListener("shopify:section:load", initAddToCart);
});
